/**
 * @version 1.0
 * @author xieyq
 * @createTime 2021/8/24
 * @updateTime 2021/8/24
 * @decription 申请保全 =》 上传材料
 */
// 模块预览组件
import ccPreviewModule from '@/components/common/preview-module/index.vue';
import ccPreviewItem from '@/components/common/preview-item/index.vue';
// 标题组件
import Slogan from '@/components/common/slogan';
// 预览文件
import acPreviewFile from '@/components/app/preview-file/index.vue';
export default {
    name: 'SCCL',
    // 混入
    mixins: [],
    // 依赖组件
    components: {
        Slogan,
        ccPreviewModule,
        ccPreviewItem,
        acPreviewFile
    },
    // 参数
    props: {
        // 依赖数据,依赖被申请人列表数据
        dependData: {
            type: Object,
            default() {
                return {};
            }
        }
    },
    // 数据
    data() {
        return {
            // 保全类别
            bqlb: '4',
            // 保全申请书文件列表
            sqsFiles: [],
            // 生效法律文书文件列表
            sxflwsFiles: [],
            // 起诉书文件列表
            qszFiles: [],
            // 立案受理通知书文件列表
            lasltzsFiles: [],
            // 身份证明材料
            sfzmFiles: [],
            // 担保材料文件列表
            dblFiles: [],
            // 证据类材料
            zjFiles: [],
            // 其他材料
            qtFiles: [],
            // 转换后的数据
            transformData: []
        };
    },
    // 计算属性
    computed: {},
    // 监听
    watch: {},
    // 创建完成
    created() {
        // 赋值保全类别
        this.bqlb = this.dependData.cBqlb;
        // 获取数据
        this.getData();
    },
    // 组件激活
    activated() {
    },
    // 组件初始化完成
    mounted() {
    },
    // 组件失去激活
    deactivated() {
    },
    // 销毁之前
    beforeDestroy() {
    },
    // 方法
    methods: {

        /**
         * 请求文件数据
         * @param {Object} params 请求参数
         * */
        requestData(params) {
            return this.$axios.get('ssbq/api/sccls/sccls', params);
        },

        /**
         * 获取行数据
         * @param {String} name 名称
         * @param {String|Number|Object} value 值
         * @returns {Object}
         * */
        getRowData(name, value) {
            return {
                name: name,
                value: value
            };
        },

        /**
         * 获取身份证明材料
         * */
        getSFZMCLFilesName(data) {
            const _fileName = [];
            data.forEach(item => {
                // 人员名称
                const name = `【${item.rymc}】`;
                // 材料列表
                const _currentFilesName = this.getFilesName(item.clList);
                _fileName.push(name + '  ' + (_currentFilesName.length ? _currentFilesName.join('  ') : '未上传') + '<br/>');
            });
            return _fileName;
        },

        /**
         * 获取担保材料文件名称
         * */
        getDBCLFilesName(data) {
            const _fileName = [];
            data.forEach(item => {
                // 担保类型名称
                _fileName.push(`【${item.dblxmc}】`);
                if (item.dblxmc.indexOf('保险公司诉责险')>-1 && item.nSysbuy === 1) {
                    _fileName.push('电子保单');
                    _fileName.push('电子保函');
                }
                _fileName.push(...this.getFilesName(item.clList));
            });
            return _fileName;
        },

        /**
         * 获取文件列表数据
         * @param {Array} data 文件数据列表
         * @returns {Array} 文件列表名称
         * */
        getFilesName(data) {
            const _filesName = [];
            data.forEach(item => {
                _filesName.push(item.cSqbqclmc);
            });
            return _filesName;
        },

        /**
         * 获取转化之后的数据
         * @returns {Array} 转化之后的信息项数组
         * */
        getTransformData(data) {
            const _transformItemData = [];
            _transformItemData.push(this.getRowData('保全申请书', this.getFilesName(data.sqs)));
            // 保全类别
            if (this.bqlb === '4') {
                _transformItemData.push(this.getRowData('生效法律文书', this.getFilesName(data.sxflws)));
            } else {
                _transformItemData.push(this.getRowData('起诉书', this.getFilesName(data.qsz)));
                _transformItemData.push(this.getRowData('立案受理通知书', this.getFilesName(data.lasltzs)));
            }
            _transformItemData.push(this.getRowData('身份证明材料', this.getSFZMCLFilesName(data.sfzml)));
            _transformItemData.push(this.getRowData('担保材料', this.getDBCLFilesName(data.dbl)));
            _transformItemData.push(this.getRowData('证据材料', this.getFilesName(data.zjl)));
            _transformItemData.push(this.getRowData('其他材料', this.getFilesName(data.qt)));
            return _transformItemData;
        },

        /**
         * 获取数据
         * */
        getData() {
            this.requestData({
                // 保全id
                bqid: sessionStorage.getItem('bqid')
            }).then(res => {
                const _transformData = [];
                // 申请书文件列表
                this.sqsFiles = res.data.sqs;
                // 生效法律文书文件列表
                this.sxflwsFiles = res.data.sxflws;
                // 起诉书文件列表
                this.qszFiles = res.data.qsz;
                // 立案受理通知书文件列表
                this.lasltzsFiles = res.data.lasltzs;
                // 身份证明材料
                this.sfzmFiles = res.data.sfzml;
                // 担保材料文件列表
                this.dblFiles = res.data.dbl;
                // 证据类材料
                this.zjFiles = res.data.zjl;
                // 其他材料
                this.qtFiles = res.data.qt;
                // 转化之后的数据
                _transformData.push(this.getTransformData(res.data));
                // 转化之后的数据
                this.transformData = _transformData;
                // 加载完成
                this.$emit('loaded', this.data);
            })
        }
    }
};
